import { Pipe, PipeTransform } from '@angular/core';
import { CONSTANTS } from '@pk/powerkioskutils';

import { Agent } from '../models';
import { LicensePlan } from '../models/license-plan';

@Pipe({
	name: 'licensePlanFilter',
	standalone: false,
})
export class LicensePlanFilterPipe implements PipeTransform {
	private newBusinessFullIds = CONSTANTS.licensePlans.platinumIds.concat(CONSTANTS.licensePlans.goldIds).concat(CONSTANTS.licensePlans.silverIds);
	private oldBusinessFullIds = CONSTANTS.licensePlans.oldPlatinumIds;
	private businessFullIds = this.newBusinessFullIds.concat(this.oldBusinessFullIds);
	private businessLiteIds = CONSTANTS.licensePlans.businessLiteIds;

	private showParentBusinessLicenses(licensePlan: LicensePlan, agent: Agent, licensePlanName: string, isAdmin: boolean) {
		const licensePlanId = licensePlan.id;

		if (licensePlan.name !== licensePlanName) {
			return false;
		}

		// for the old plans and business lite, check if the agent has the license plan to be able to show it (admin can always see it)
		if (this.oldBusinessFullIds.includes(licensePlanId) || this.businessLiteIds.includes(licensePlanId)) {
			return agent.hasLicensePlan(licensePlanId) || isAdmin;
		}

		return this.businessFullIds.includes(licensePlanId);
	}

	private showBusinessNoCharge(licensePlan: LicensePlan, agent: Agent, isAdmin: boolean) {
		const hasNoCharge = licensePlan.monthlyFee === 0 && licensePlan.upfrontFee === 0;
		return !hasNoCharge || agent.hasSeparateBusinessNoCharge() || isAdmin;
	}

	transform(licensePlans: LicensePlan[], agent: Agent, licensePlanName: string, isAdmin: boolean): any {
		if (!licensePlans) {
			return licensePlans;
		}

		return licensePlans.filter(
			l => this.showParentBusinessLicenses(l, agent, licensePlanName, isAdmin) && this.showBusinessNoCharge(l, agent, isAdmin),
		);
	}
}
